import type { TradeItem, TradeType } from './types'

/** Recompute header totals from line items (optimistic UI). */
export function recomputeTradeTotals(trade: TradeType, items: TradeItem[]): TradeType {
  let storeValueCents = 0
  let customerValueCents = 0

  for (const it of items) {
    const line =
      typeof it.totalValueCents === 'number'
        ? it.totalValueCents
        : Math.max(0, (it.quantity || 0) * (it.valueCents || 0))
    if (it.side === 'store') storeValueCents += line
    else customerValueCents += line
  }

  return {
    ...trade,
    items,
    storeItems: items.filter((i) => i.side === 'store'),
    customerItems: items.filter((i) => i.side === 'customer'),
    storeValueCents,
    customerValueCents,
    differenceValueCents: storeValueCents - customerValueCents,
  }
}

export function optimisticQuantityChange(
  trade: TradeType,
  itemId: string,
  newQuantity: number,
): TradeType {
  const items = (trade.items || []).map((it) => {
    if (it.id !== itemId) return it
    const q = Math.max(1, newQuantity)
    const totalValueCents = q * (it.valueCents || 0)
    return { ...it, quantity: q, totalValueCents }
  })
  return recomputeTradeTotals(trade, items)
}

export function optimisticRemoveItem(trade: TradeType, itemId: string): TradeType {
  const items = (trade.items || []).filter((it) => it.id !== itemId)
  return recomputeTradeTotals(trade, items)
}
